/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSplitStatusDto
 */
export interface PaymentSplitStatusDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitStatusDto
     */
    commissionAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitStatusDto
     */
    grossAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitStatusDto
     */
    grossAmountAfterAddingTerminalTip: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentSplitStatusDto
     */
    locationId: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitStatusDto
     */
    netAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitStatusDto
     */
    paymentFeeAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitStatusDto
     */
    pendingRefundAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitStatusDto
     */
    refundableAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitStatusDto
     */
    refundedAmount: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentSplitStatusDto
     */
    terminalTipAmount: string;
}

/**
 * Check if a given object implements the PaymentSplitStatusDto interface.
 */
export function instanceOfPaymentSplitStatusDto(value: object): value is PaymentSplitStatusDto {
    if (!('commissionAmount' in value) || value['commissionAmount'] === undefined) return false;
    if (!('grossAmount' in value) || value['grossAmount'] === undefined) return false;
    if (!('grossAmountAfterAddingTerminalTip' in value) || value['grossAmountAfterAddingTerminalTip'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('netAmount' in value) || value['netAmount'] === undefined) return false;
    if (!('paymentFeeAmount' in value) || value['paymentFeeAmount'] === undefined) return false;
    if (!('pendingRefundAmount' in value) || value['pendingRefundAmount'] === undefined) return false;
    if (!('refundableAmount' in value) || value['refundableAmount'] === undefined) return false;
    if (!('refundedAmount' in value) || value['refundedAmount'] === undefined) return false;
    if (!('terminalTipAmount' in value) || value['terminalTipAmount'] === undefined) return false;
    return true;
}

export function PaymentSplitStatusDtoFromJSON(json: any): PaymentSplitStatusDto {
    return PaymentSplitStatusDtoFromJSONTyped(json, false);
}

export function PaymentSplitStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSplitStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'commissionAmount': json['commissionAmount'],
        'grossAmount': json['grossAmount'],
        'grossAmountAfterAddingTerminalTip': json['grossAmountAfterAddingTerminalTip'],
        'locationId': json['locationId'],
        'netAmount': json['netAmount'],
        'paymentFeeAmount': json['paymentFeeAmount'],
        'pendingRefundAmount': json['pendingRefundAmount'],
        'refundableAmount': json['refundableAmount'],
        'refundedAmount': json['refundedAmount'],
        'terminalTipAmount': json['terminalTipAmount'],
    };
}

export function PaymentSplitStatusDtoToJSON(json: any): PaymentSplitStatusDto {
    return PaymentSplitStatusDtoToJSONTyped(json, false);
}

export function PaymentSplitStatusDtoToJSONTyped(value?: PaymentSplitStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'commissionAmount': value['commissionAmount'],
        'grossAmount': value['grossAmount'],
        'grossAmountAfterAddingTerminalTip': value['grossAmountAfterAddingTerminalTip'],
        'locationId': value['locationId'],
        'netAmount': value['netAmount'],
        'paymentFeeAmount': value['paymentFeeAmount'],
        'pendingRefundAmount': value['pendingRefundAmount'],
        'refundableAmount': value['refundableAmount'],
        'refundedAmount': value['refundedAmount'],
        'terminalTipAmount': value['terminalTipAmount'],
    };
}

